import React from "react";

const SvgAnswer = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 8 9"
    fill="none"
  >
    <path
      d="M1.36009 9H0.252131L3.45668 0.272727H4.54759L7.75213 9H6.64418L4.03622 1.65341H3.96804L1.36009 9ZM1.76918 5.59091H6.23509V6.52841H1.76918V5.59091Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgAnswer;
